<template>
  <v-container
    class="cycle-row"
    :class="{
      'nitro': cycle.is_current
    }"
  >
    <v-row>
      <v-col
        class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-start"
        cols="2"
        sm="3"
      >
        <CycleImg
          :cycle="cycle"
        />
        <div
          class="ml-sm-1"
          :class="{
            'white--text' : cycle.is_current && cycle.started ,
            'nitro--text' : !cycle.is_current && cycle.started
          }"
        >
          <p class="m-0 font-weight-bold d-none d-sm-inline">
            {{ cycle.cycle_name }}
          </p>
          <p class="m-0 cycle_dates">
            {{ cycle.begin_formatted_day_month }} 
            <span class="d-none d-sm-inline font-weight-normal"> - </span>
            {{ cycle.end_formatted_day_month }}
          </p>
        </div>
      </v-col>
      <v-col 
        v-if="!cycle.should_select_modules"
        class="d-flex justify-content-end py-0"
        cols="6" 
      >
        <CycleModules :cycle="cycle" />
      </v-col>
      <v-col
        v-if="!cycle.should_select_modules"
        cols="2"
        class="px-0 d-flex justify-content-center"
      >
        <ChallengeInfo :cycle="cycle" />
        <span style="width:19px">&nbsp;</span>
        <ScoreInfo :cycle="cycle" />
      </v-col>
      <v-col
        v-if="!cycle.should_select_modules"
        cols="2"
        sm="1"
        class="d-flex align-items-center justify-content-end"
      >
        <RedirectButton :cycle="cycle" />
      </v-col>
      <v-col
        v-if="cycle.should_select_modules"
        class="d-flex justify-content-end align-items-center select-modules"
      >
        <p class="text-white">
          Você ainda não selecionou módulos <br>
          de desempenho neste ciclo
        </p>
      </v-col>
      <v-col
        v-if="cycle.should_select_modules"
        cols="4"
        class="d-flex justify-content-center align-items-center select-modules"
      >
        <v-btn
          outlined
          class="text-white border"
          :to="{ name: selectModulesRouteName }"
        >
          Selecionar módulos
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import CycleImg from './CycleImg.vue'
import ScoreInfo from './ScoreInfo.vue'
import ChallengeInfo from './ChallengeInfo.vue'
import CycleModules from './CycleModules.vue'
import RedirectButton from './RedirectButton.vue'
import { selectModulesRouteName } from "@/student/constants/routes"

export default {
    components: { CycleImg , CycleModules, RedirectButton, ScoreInfo, ChallengeInfo },
    props: {
        cycle: {
            type: Object,
            required: true,
        }
    },
    data(){
      return {
        selectModulesRouteName,
      }
    }
    
}
</script>
<style lang="scss" >
  .cycle-row {

    .select-modules {
      
      font-size: 9px;
      font-weight: 600;
      
      @media screen and (min-width: 768px) {
        font-size: 14px;
      }
      
      a.v-btn {
        font-weight: 600;
        font-size: 7px;
        letter-spacing: 0;
        max-width: 104px !important;
        height: 25px !important;
          @media screen and (min-width: 768px) {
            font-size: 14px;
            max-width: 177px!important;
            height: 37px !important;
          }
      }

    }
    p.cycle_dates {
      
      font-size: 9px;

      @media screen and (min-width: 768px) {
        font-size: 14px;
      }

    }
    p {
      margin: 0
    }
    .container-info{
      border-radius: 8px !important;
      
      text-align: center;
      cursor: pointer;
      &:hover{
        background: #E7E9EF;
      }
      &:hover.is_current{
        background: rgba($color: #000000, $alpha: 0.1);
      }
      .sub-text{
        font-size: 9px;
        text-align: center;
        font-weight: bold;
        @media screen and (min-width: 768px) {
          font-size: 12px;
        }
      }
      .info-text {
        display: inline-flex; 
        justify-content: center;
        align-items: center; 
        text-align: center;
        height: 30px;
        width: 30px;
        @media screen and (min-width: 768px) {
          height: 40px;
          width: 40px;
        }
        p {
          font-size: 9px;
          @media screen and (min-width: 768px) {
            font-size: 12px;
          }
        }

      }
    }
  }
    
</style>